import type { JSX } from 'react'

export const BookmarkIcon = (): JSX.Element => (
  <use href='#bookmarkIcon' height='100%' width='100%' />
)
